var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"footer"}},[_c('div',[_c('div',{staticClass:"version"},[_c('p',[_vm._v("PEAK Version "+_vm._s(_vm.version))]),_c('p',[_vm._v("© "+_vm._s(_vm.CurrentYear)+" PEAK All rights reserved.")])]),_c('div',{staticClass:"privacy"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }